import api from '@/api';

const resource = 'merenda/cardapio';

export default {
  criarCardapio( data ) {
    return api.post( `${resource}`, data );
  },

  editarCardapio( data ) {
    return api.put( `${resource}/${data.identificadorcardapio}`, data);
  },

  deletarCardapio( identificadorcardapio ) {
    return api.delete(`${resource}/${identificadorcardapio}`);
  },

  buscarCardapios() {
    return api.get( `${resource}` );
  },

  buscarCardapiosPorTitulo(identificadortitulocardapio) {
    return api.get( `${resource}?identificadortitulocardapio=${identificadortitulocardapio}` );
  },

  inserirPreparacoes(dados) {
    return api.post( `${resource}/preparacoes`, dados );
  },

  buscarHorarios(identificadortitulocardapio, anocardapio) {
    return api.get( `${resource}/horarios?identificadortitulocardapio=${identificadortitulocardapio}&anocardapio=${anocardapio}` );
  },
};
